module.exports = __webpack_public_path__ + "static/media/dashboard.245e0996.svg";